import { AxiosError } from "axios";

import { AccountData } from "../../../../api/useGetAccountDetails";
import { CustomerSummaryData } from "../../../../api/useGetCustomerSummary";
import { displayValue } from "../../../../utils/formatVariables";
import { getDateAndTimeString } from "../../../../utils/getDateString";
import InlineError from "../../../InlineError";

export interface Data {
  label: string;
  value: string | number | JSX.Element;
  isNumeric?: boolean;
}

export const buildCustomerSummary = (
  customerSummaryData: Partial<CustomerSummaryData>,
  accountDetails: AccountData,
  accountDetailsError: AxiosError<unknown, any> | null
) => {
  const {
    closeRestriction,
    restrictReason,
    correspondentCode,
    restrictDate,
    account: number,
    dayTraderType: patternDayTrader,
    officeRepCode: primaryRegisteredRepId,
    accountName: title,
    dayTradeCount,
  } = customerSummaryData;

  let accountRegistrationValue, marginTypeValue;
  if (accountDetails) {
    const { accountRegistration, marginType } = accountDetails;
    accountRegistrationValue = accountRegistration;
    marginTypeValue = marginType;
  } else {
    accountRegistrationValue = "error";
    marginTypeValue = "error";
  }

  return [
    {
      label: "Account Name",
      value: displayValue(title),
    },
    {
      label: "Correspondent",
      value: displayValue(correspondentCode),
    },
    {
      label: "Office/Rep. Code",
      value: displayValue(primaryRegisteredRepId),
    },
    {
      label: "Close Restriction",
      value: displayValue(closeRestriction),
    },
    {
      label: "Restrict Reason",
      value: displayValue(restrictReason),
    },
    {
      label: "Restrict Date",
      value: restrictDate ? getDateAndTimeString(restrictDate) : <>&mdash;</>,
    },
    {
      label: "Account Number",
      value: displayValue(number),
    },
    {
      label: "Account Registration",
      value: accountDetailsError ? <InlineError /> : accountRegistrationValue,
    },
    {
      label: "Margin Type",
      value: accountDetailsError ? <InlineError /> : marginTypeValue,
    },
    {
      label: "Day Trade Count",
      value: dayTradeCount,
    },
    {
      label: "Day Trader Status",
      value: patternDayTrader ? "PDT" : "non-PDT",
    },
  ];
};
